/* ----------------------------------------------------------------------------
js entry point: mobile menu, client-side event expiry, YouTube click-to-load
---------------------------------------------------------------------------- */

// Mobile menu
const header = document.querySelector('[data-site-header]');
const menuButton = header?.querySelector('[data-menu-button]');
if (header && menuButton) {
	const setOpen = (open) => {
		header.classList.toggle('nav-open', open);
		menuButton.setAttribute('aria-expanded', String(open));
		menuButton.textContent = open ? 'Close' : 'Menu';
	};
	menuButton.addEventListener('click', () =>
		setOpen(!header.classList.contains('nav-open')),
	);
	for (const link of header.querySelectorAll('.nav a')) {
		link.addEventListener('click', () => setOpen(false));
	}
	document.addEventListener('keydown', (event) => {
		if (event.key === 'Escape' && header.classList.contains('nav-open')) {
			setOpen(false);
			menuButton.focus();
		}
	});
}

// Hide events that expired since the last build (YYYY-MM-DD string compare)
const today = new Date().toLocaleDateString('en-CA');
for (const event of document.querySelectorAll('[data-expires]')) {
	if (event.dataset.expires < today) event.remove();
}
for (const list of document.querySelectorAll('[data-events]')) {
	if (!list.querySelector('.event')) list.remove();
}

// YouTube: load the player only when asked (privacy + speed)
for (const box of document.querySelectorAll('[data-youtube]')) {
	box.querySelector('.play')?.addEventListener('click', (event) => {
		event.preventDefault();
		const iframe = document.createElement('iframe');
		iframe.src = `https://www.youtube-nocookie.com/embed/${box.dataset.youtube}?autoplay=1`;
		iframe.title = box.dataset.title || 'Sermon video';
		iframe.allow =
			'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
		iframe.allowFullscreen = true;
		box.replaceChildren(iframe);
		iframe.focus();
	});
}
